<template>
	<div class="font-sans leading-normal tracking-normal">
		<suspense>
			<template #default>
				<div class="min-h-screen bg-gray-100 flex justify-center items-center">
					<header class="fixed w-full top-0 z-40">
						<div class="bg-white shadow py-3 md:py-5 z-10 h-auto">
							<div class="container mx-auto px-4 sm:flex items-center md:px-8">
								<div class="mx-auto sm:ml-0">
									<img class="mx-auto h-6 md:h-8" :src="require('@/assets/image/dish-outdoors.svg')">
								</div>
								<a class="block text-center mt-2 text-dish-red font-bold text-2xl sm:mt-0 md:text-2xl" :href="url">{{ phone }}</a>
							</div>
						</div>
					</header>
					<router-view class="mt-20 sm:mt-12 md:mt-16" />
				</div>
			</template>
			<template #fallback>
				<div class="flex w-full min-h-screen py-16 px-4 justify-center items-center bg-gray-100">
					<div>
						<img class="max-w-xs w-full" :src="require('@/assets/image/dish-outdoors.svg')">

						<div class="relative mx-auto mt-6 h-12 w-12">
							<div class="absolute inset-0 border-dish-red border-8 rounded-full" />
							<div class="absolute inset-0 border-white border-opacity-50 border-l-transparent animate-spin border-8 rounded-full" />
						</div>
					</div>
				</div>
			</template>
		</suspense>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	import { useDynamicPhoneNumber } from '@/composables/useDynamicPhoneNumber'

	export default defineComponent({
		setup() {
			return useDynamicPhoneNumber('1-877-790-1540')
		},
	})
</script>
